/* eslint-disable css-modules/no-unused-class */
/* eslint-disable arrow-body-style */

import React from 'react';

import cn from 'classnames';
import { bool, func, node, oneOf, oneOfType, string } from 'prop-types';

import Typography from '@mui/material/Typography';

import { getColor } from 'utils/colors';

import s from './Text.css';

// These variants are not provided by MUI
// by passing them into classes OR variant will cause
// console error
export const CUSTOM_VARIANT_LIST = [
  'lead',
  'leadBold',
  'titleMd',
  'titleMdBold',
  'titleSm',
  'titleSmBold',
  'bodyMd',
  'bodyMdBold',
  'bodySm',
  'bodySmBold',
  'meta',
  'metaBold',
  'label',
  'tiny',
  'mono',
  'cursive',
  'stat1',
  'stat2',
  'stat3',
  'stat4',
  'stat5',
  'stat6',
];

/* Don't remove the return, it works in project but fails in Storybook. */
const Text = React.forwardRef(
  (
    {
      align,
      children,
      variant,
      className,
      color,
      component,
      isBold,
      isItalic,
      isRebrand,
      isRebrandUnderlined,
      ...restProps
    },
    ref,
  ) => {
    return (
      <Typography
        align={align}
        className={cn(s.textWrapper, s?.[variant], className, {
          [s.italic]: isItalic,
          [s.bold]: isBold,
          [s.rebrand]: isRebrand,
          [s.rebrandUnderlined]: isRebrandUnderlined,
        })}
        variant={CUSTOM_VARIANT_LIST.includes(variant) ? 'body1' : variant}
        sx={{
          color: getColor({ color }),
        }}
        component={component}
        ref={ref}
        {...restProps}
      >
        {children}
      </Typography>
    );
  },
);

Text.propTypes = {
  align: oneOf(['inherit', 'left', 'center', 'right', 'justify']),
  color: string,
  component: oneOfType([string, func]),
  children: node.isRequired,
  className: string,
  isBold: bool,
  isItalic: bool,
  variant: string,
  isRebrand: bool,
  isRebrandUnderlined: bool,
};

Text.defaultProps = {
  align: undefined,
  color: 'font',
  className: null,
  /*
    To change the element that going to be rendered, pass element name as a string.
    passing p as a component doesn't override the heading tags,
    but div and span overrides those too.

    Documentation for related prop: https://mui.com/api/typography/#:~:text=for%20more%20details.-,component,-elementType
  */
  component: 'p',
  isBold: false,
  isItalic: false,
  variant: 'body1',
  isRebrand: false,
  isRebrandUnderlined: false,
};
export default Text;
